export default __webpack_public_path__ + "static/media/add-to-playlist.13031b2c.svg";